import { render, staticRenderFns } from "./StatesList.vue?vue&type=template&id=6036b00d&"
import script from "./StatesList.vue?vue&type=script&lang=js&"
export * from "./StatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports